import request from '@/utils/request'

// 运营日志列表
export function mctLogList(params) {
  return request({
    url: '/mct_operate_log/v1',
    params
  })
}

// 运营日志点赞列表
export function mctLogLiveList(params) {
  return request({
    url: '/operate_log_evaluate/list/v1',
    params
  })
}

// 运营日志点赞
export function mctLogLive(data) {
  return request({
    url: '/operate_log_evaluate/v1',
    method: 'POST',
    data
  })
}

// 运营日志评论列表
export function mctLogMarkList(params) {
  return request({
    url: '/operate_log_comment/list/v1',
    params
  })
}

// 运营日志评论
export function mctLogMark(data) {
  return request({
    url: '/operate_log_comment/v1',
    method: 'POST',
    data
  })
}

// 获取配送员
export function getGenerateName(params) {
  return request({
    url: '/worker/selected/v1',
    params
  })
}